/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditBannerPage,
    openDeleteBannerDialog,
  }
) => (
  <>
    <>
      <a
        title="Edit Banner"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditBannerPage(row._id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            title="Edit Banner"
          />
        </span>
      </a>
      <a
        title="Delete Banner"
        className="btn btn-icon btn-light btn-hover-info btn-sm"
        onClick={() => openDeleteBannerDialog(row._id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} title="Delete Banner"/>
        </span>
      </a>
    </>
  </>
);
